import React from "react";
import PropTypes from "prop-types";

import { STREAM_TYPE, DEFAULT_CARD_HEIGHT } from "config/constants";
import StandardLayout from "components/Library/Layout/containers/StandardLayout";
import LatestStories from "components/Library/LatestStories";
import TagStreamHeader from "stream/components/TagStreamHeader";
import TagStreamHelmet from "stream/components/TagStreamHelmet";

const TagStreamWrapper = props => {
  const HeaderComponent = props.headerComponent || TagStreamHeader;
  const streamParams = {
    type: STREAM_TYPE.TAG,
    lookup: props.slug,
    onlyShowTitleForA11y: true,
  };

  return (
    <React.Fragment>
      <TagStreamHelmet slug={props.slug} />
      <HeaderComponent slug={props.slug} />
      <StandardLayout
        main={props.children({ streamParams })}
        complementary={<LatestStories />}
        mainAriaLabel="Stories"
      />
    </React.Fragment>
  );
};

TagStreamWrapper.propTypes = {
  slug: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
  headerComponent: PropTypes.func,
};

export default TagStreamWrapper;
